import * as React from 'react';
import {
  Collapse,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  useTheme,
} from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { FirstLayerSubmenu, MenuOption, SecondLayerSubMenu } from '..';

export function MenuOptionItem({
  menuOption,
  handleClick,
  openedMenu,
}: {
  menuOption: MenuOption;
  handleClick: () => void;
  openedMenu: string;
}) {
  const theme = useTheme();

  const isGroup = menuOption.type === 'group';

  const isOpenMenu = openedMenu === menuOption.type;

  return (
    <React.Fragment>
      <ListItem sx={{ padding: 0, paddingX: 1 }}>
        <ListItemButton
          onClick={handleClick}
          // sx={{
          //   bgcolor: isOpenMenu
          //     ? theme.palette['Ambient/Grayscale/Gray-50']
          //     : 'transparent',
          // }}
        >
          <ListItemIcon>{menuOption.icon}</ListItemIcon>
          <ListItemText
            sx={{ marginLeft: theme.spacing(-2) }}
            primary={
              <Typography
                variant="Headlines/Medium"
                color={menuOption.color ?? 'Ambient/Base/Black'}
              >
                {menuOption.title}
              </Typography>
            }
          />

          {isGroup ? (
            isOpenMenu ? (
              <ChevronLeft
                sx={{
                  rotate: '-90deg',
                  color: 'Brand/Solid/Primary',
                }}
              />
            ) : (
              <ChevronRight sx={{ color: 'Ambient/Neutrals/Table-Head-BG' }} />
            )
          ) : null}
        </ListItemButton>
      </ListItem>

      {isGroup && (
        <Collapse timeout="auto" unmountOnExit>
          <List component="nav"></List>
        </Collapse>
      )}
    </React.Fragment>
  );
}

export function LayerSubmenuItem({
  menuOption,
  handleClick,
  color,
}: {
  menuOption: FirstLayerSubmenu | SecondLayerSubMenu;
  handleClick: () => void;
  color?: string;
}) {
  const theme = useTheme();

  const isGroup = menuOption.type === 'group';

  return (
    <React.Fragment>
      <ListItem sx={{ padding: 0, paddingX: 1 }}>
        <ListItemButton
          sx={{ padding: 1, paddingLeft: 3, paddingRight: 2 }}
          onClick={handleClick}
        >
          <ListItemText
            sx={{ marginLeft: theme.spacing(-2) }}
            primary={
              <Typography
                variant="Headlines/Medium"
                color={color ?? 'Ambient/Base/Black'}
              >
                {menuOption.title}
              </Typography>
            }
          />

          {isGroup && (
            <ChevronRight sx={{ color: 'Ambient/Neutrals/Table-Head-BG' }} />
          )}
        </ListItemButton>
      </ListItem>

      {isGroup && (
        <Collapse timeout="auto" unmountOnExit>
          <List component="nav"></List>
        </Collapse>
      )}
    </React.Fragment>
  );
}
